import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './map.scss';
import Pin from '../pin/Pin';

function Map({ items }) {
  // Функция для вычисления центра карты
  const getDefaultCenter = () => {
    if (items.length === 0) {
      // Если `items` пустой массив, установить центр по умолчанию
      return [0, 0]; // Например, координаты экватора
    }

    // Проверяем первый элемент на наличие `latitude` и `longitude`
    const latitude = items[0]?.latitude ?? 0;
    const longitude = items[0]?.longitude ?? 0;

    return [latitude, longitude];
  };

  return (
    <MapContainer
      center={getDefaultCenter()}
      zoom={7}
      scrollWheelZoom={false}
      className="map"
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {items.map(
        (item) =>
          // Рендерим только элементы с корректными координатами
          item.latitude !== undefined &&
          item.longitude !== undefined && <Pin item={item} key={item.id} />
      )}
    </MapContainer>
  );
}

export default Map;
